var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFluent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0005 1.47266V6.88932C10.0005 7.36819 10.1908 7.82744 10.5294 8.16604C10.868 8.50465 11.3272 8.69488 11.8061 8.69488H17.2228V17.7227C17.2228 18.2015 17.0325 18.6608 16.6939 18.9994C16.3553 19.338 15.8961 19.5282 15.4172 19.5282H4.58388C4.10501 19.5282 3.64576 19.338 3.30716 18.9994C2.96855 18.6608 2.77832 18.2015 2.77832 17.7227V3.27821C2.77832 2.79935 2.96855 2.3401 3.30716 2.00149C3.64576 1.66288 4.10501 1.47266 4.58388 1.47266H10.0005Z",
    fill: "#393839"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3545 1.92383V6.88911C11.3545 7.00882 11.402 7.12363 11.4867 7.20829C11.5714 7.29294 11.6862 7.3405 11.8059 7.3405H16.7712L11.3545 1.92383Z",
    fill: "#393839"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFluent);
export default __webpack_public_path__ + "static/media/Fluent.60a4656c80bbb28cff313e558120978a.svg";
export { ForwardRef as ReactComponent };